import './Header.scss'

export const Header = () => {
    return (
        <header className='header'>
            <div className="container">
                <div onClick={() => window.location.href = '/'} className='header__container'>
                    <h1 className='header__title'>
                        Таблица финансовых показателей
                    </h1>
                </div>
            </div>
        </header>
    )
} 